import React, { useCallback } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { PriceRoundingRuleConfigSchema } from './roundingRuleSchema';
import { IconButton, Stack } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useMountEffect } from '@shared/hooks';
import { RemovablePriceInput } from './RemoveablePriceInput';

interface Props {
  index: number;
}

export const TargetEndingsInputCell: React.FC<Props> = ({ index }) => {
  const { control } = useFormContext<PriceRoundingRuleConfigSchema>();
  const { fields, append, remove } = useFieldArray({
    control,
    // @ts-ignore
    name: `rules.${index}.targetEndings`,
  });

  const addTargetEnding = useCallback(() => {
    // @ts-ignore
    append('');
  }, [append]);

  useMountEffect(() => {
    if (fields.length === 0) {
      addTargetEnding();
    }
  });

  return (
    <Stack direction="row" gap={1} py={2} sx={{ alignItems: 'center' }} flexWrap="wrap">
      {fields.map((field, fieldIndex) => (
        <RemovablePriceInput
          key={field.id}
          control={control}
          name={`rules.${index}.targetEndings.${fieldIndex}`}
          size="xs"
          onRemove={fieldIndex > 0 ? () => remove(fieldIndex) : undefined}
          sx={{ width: '120px' }}
        />
      ))}
      <IconButton
        size="small"
        onClick={addTargetEnding}
        sx={(theme) => ({
          bgcolor: 'secondary.main',
          color: 'text.primary',
          transform: 'scale(0.8)',
          ...theme.applyStyles('dark', { color: 'background.default' }),
        })}
      >
        <Add />
      </IconButton>
    </Stack>
  );
};
